import { MONEY_TRANSFER } from "../../constants/actionTypes";
import initialState from "../initialState";

export default function availableCities(
  state = initialState.moneyTransfer.availableCities,
  action
) {
  switch (action.type) {
    case MONEY_TRANSFER.GET_AVAILABLE_CITIES: {
      let cities = [];
      try {
        cities = action.availableCities.slice().map((city: { label: string, value: string }) => {
          return {
            name: city.label,
            iso: city.value
          }
        })
      } catch (err) {
        // If there is an error retrieving available countries we don't need to inform the user because
        // they should be prevented from entering a money transfer flow.
        // The actual error error at the API level should be logged API side.
        cities = [];
      }

      state = cities;
      return cities;
    }
    default:
      return state;
  }
}